import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ButtonComp from "../../../components/Button";
import { useClaimFormStore } from "../../../store/useClaimFormStore";
import { useEffect, useState } from "react";
import { string } from "../../../constants/string";

export default function ClaimDocument(props: any) {
  const {
    handleBenefitCommentChange,
    benefitComment,
    commentDetails,
    claimBenefitInfo,
  } = props;
  const { handleBack, handleBenefitNext } = props;
  const [benefitType, setBenefitType] = useState("Cash Only");
  const [selectedOptions, setSelectedOptions] = useState<{
    [key: string]: string;
  }>({});
  const comments = commentDetails?.filter(
    (comment: any) => comment.section_type === "CLAIMS_BENEFIT_SCHEDULE"
  );

  const parseAmount = (value: any) => parseFloat(value || "0") || 0;

  // Filter and sum cash values
  const totalCash = claimBenefitInfo
    ?.map((item: any) => parseAmount(item.cash))
    .reduce((acc: any, curr: any) => acc + curr, 0);

  // Filter and sum service values
  const totalService = claimBenefitInfo
    ?.map((item: any) => parseAmount(item.service))
    .reduce((acc: any, curr: any) => acc + curr, 0);

  return (

    <>
      <Box
        sx={{
          width: { xs: "100%", md: "50%", lg: "80%" },
          border: "1px solid #DFDDDD",
          my: 3,
        }}
      >
        <Box
          sx={{
            bgcolor: "#f5f5f5",
            p: 2,
            borderRadius: 1,
            mb: 2,
          }}
        >
          <Typography textAlign="left" fontWeight={700} fontSize={16} mb={1}>
            Product
          </Typography>
          <Grid container>
            <Grid size={{ xs: 6 }}>
              <Typography fontWeight={600} fontSize={16} align="left">
                {claimBenefitInfo?.[0]?.product_name || "Product Name"}
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 6 }}
              display="flex"
              justifyContent="flex-end"
              gap={1}
              flexDirection="column"
            >
              <Typography
                align="right"
                fontSize={18}
                fontWeight={600}
                color="#EC6E00"
              >
                {claimBenefitInfo?.[0]?.cash_and_service
                  ? "Cash and Service"
                  : claimBenefitInfo?.[0]?.cash_only
                  ? "Cash Only"
                  : claimBenefitInfo?.[0]?.service_only
                  ? "Service Only"
                  : "-"}
              </Typography>
              <Box textAlign="right">
                {claimBenefitInfo?.[0]?.cash_and_service ? (
                  <>
                    <Typography fontSize={16}>
                      Cash Amount: R{claimBenefitInfo[0]?.cash || 0}
                    </Typography>
                    <Typography fontSize={16}>
                      Service Amount: R{claimBenefitInfo[0]?.service || 0}
                    </Typography>
                  </>
                ) : claimBenefitInfo?.[0]?.cash_only ? (
                  <Typography fontSize={16}>
                    Cash Amount: R{claimBenefitInfo[0]?.cash || 0}
                  </Typography>
                ) : claimBenefitInfo?.[0]?.service_only ? (
                  <Typography fontSize={16}>
                    Service Amount: R{claimBenefitInfo[0]?.service || 0}
                  </Typography>
                ) : (
                  <Typography fontSize={18}>-</Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Topup rows */}
        <Typography
          textAlign="left"
          fontWeight={700}
          fontSize={16}
          ml={2}
        >
          TopUps
        </Typography>

        <Grid
          container
          alignItems="center"
          key={""}
          spacing={1}
        >
          <Grid size={{ xs: 4 }}>
            <Typography fontWeight={600} fontSize={16} textAlign="left" ml={2}>
              {claimBenefitInfo[1]?.supplementary_name}
            </Typography>
          </Grid>

          <Grid size={{ xs: 4 }}>
            <Typography fontWeight={400} fontSize={16}>
              {claimBenefitInfo[1]?.cash_only
                ? `R${claimBenefitInfo[1]?.cash || 0}`
                : claimBenefitInfo[1]?.service_only ||
                  claimBenefitInfo[1]?.service
                ? `R${claimBenefitInfo[1]?.service || 0}`
                : "-"}
            </Typography>
          </Grid>

          <Grid size={{ xs: 4 }} display="flex" justifyContent="flex-end">
            <RadioGroup
              row
              value={
                claimBenefitInfo[1]?.cash_only
                  ? "Cash"
                  : claimBenefitInfo[1]?.service_only ||
                    claimBenefitInfo[1]?.service
                  ? "Service"
                  : ""
              }
            >
              <FormControlLabel
                value="Cash"
                control={<Radio color="warning" />}
                label={<Typography fontSize={16}>Cash Payout</Typography>}
                disabled={
                  claimBenefitInfo[1]?.cash_only ||
                  claimBenefitInfo[1]?.service_only ||
                  claimBenefitInfo[1]?.service
                }
                sx={{ mr: 4 }}
              />
              <FormControlLabel
                value="Service"
                control={<Radio color="warning" />}
                label={<Typography fontSize={16}>Service</Typography>}
                disabled={
                  claimBenefitInfo[1]?.cash_only ||
                  claimBenefitInfo[1]?.service_only ||
                  claimBenefitInfo[1]?.service
                }
              />
            </RadioGroup>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2, mx: 3 }} />

        <Grid container spacing={1}>
          {totalCash !== 0 && (
            <Grid
              size={{ xs: 8 }}
              display="flex"
              justifyContent="space-between"
              width="100%"
              px={3}
            >
              <Typography color="#EC6E00" fontWeight={700} fontSize={16}>
                Total Cash Payable
              </Typography>
              <Typography fontWeight={600}>R{totalCash}</Typography>
            </Grid>
          )}

          {totalService !== 0 && (
            <Grid
              size={{ xs: 8 }}
              display="flex"
              justifyContent="space-between"
              width="100%"
              px={3}
            >
              <Typography fontWeight={700} fontSize={16} color="#EC6E00">
                Total Service Payable
              </Typography>
              <Typography fontWeight={600}>R{totalService}</Typography>
            </Grid>
          )}
          <Grid size={{ xs: 6 }}></Grid>
        </Grid>
      </Box>
      <Grid size={{ xs: 12 }}>
        <Box width={270} height={48}>
          <Typography fontWeight={600} textAlign="left" fontSize={18}>
            Claim documents
          </Typography>
          <Box
            sx={{
              background: "#F5EEE9",
              color: "#FF0000",
              borderRadius: 1,
              px: 1.5,
              py: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <PictureAsPdfIcon />
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
            >
              <Typography fontSize={14}>Document.pdf</Typography>
              <Typography fontSize={12} color="text.secondary">
                zip 10.43 MB
              </Typography>
            </Box>
            <FileDownloadRoundedIcon />
          </Box>
        </Box>
      </Grid>
      {comments?.length > 0 && (
        <Grid size={12} mt={7}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    |{" "}
                    {new Date(comment.created_on).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  fontSize={15}
                  color="#333"
                  lineHeight={1.6}
                  textAlign="left"
                >
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      <Grid size={{ md: 12 }} mt={6}>
        <Typography
          variant="body1"
          fontWeight={600}
          fontSize={18}
          sx={{ display: "block", textAlign: "left" }}
        >
          Comment
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          onChange={handleBenefitCommentChange}
          value={benefitComment}
        />
      </Grid>
    </>
  );
}
